export default {"src":"/pro/_next/static/media/wlfi.89a7ee0e.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};